import styles from "../styles.module.scss";
import {useAppData} from "../../context/Contexts";
import {useQuery} from "@tanstack/react-query";
import {useState, useEffect, useCallback} from "react";
import fetchCheck from "../../services/CheckService";
import useCustomProductQuery from "../../services/CustomProductService";
import {slugify} from "../../helpers/helpers";


export default function Step1() {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [disabledMakes, setDisabledMakes] = useState<boolean>(true);
    const [disabledModels, setDisabledModels] = useState<boolean>(true);
    const [showTrims, setShowTrims] = useState<boolean>(false);
    const [trims, setTrims] = useState<object>({});

    const [images, setImages] = useState<[]>([]);
    const [visited, setVisited] = useState<boolean>(false);

    const [oldModel, setOldModel] = useState<string | undefined>('-');

    const {
        custom_status,
        custom_data,
        custom_error,
        custom_isFetching,
        custom_refetch
    } = useCustomProductQuery();

    let type = 'normal';
    if (window?.is_real_truck) {
        type = 'realtruck';
    } else if (window?.scs_force_custom) {
        type = 'custom';
    }

    useEffect(() => {
        if (currentAppData?.originalProduct) {
            setImages([...currentAppData?.originalProduct?.images?.edges]);
        }
    }, [currentAppData?.originalProduct]);

    const fetchYears = async () => {
        const year = currentAppData?.year;
        const make = currentAppData?.make;
        const model = currentAppData?.model;
        const trim = currentAppData?.trim;


        let query = `?type=${type}`;
        if (make && model && year) {
            query += `&make=${make}&model=${model}&year=${year}&trim=${trim}`;
        }
        // console.log(make, model, year, query);
        const urlYears = "https://scsbiz.wearevisum.com/api/v1/years" + query;
        const response = await fetch(urlYears, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).catch(error => console.log('error', error));

        const data = await response?.json();

        return data.years;
    };
    const fetchMakes = async () => {
        const year = currentAppData?.year;
        if (!year) return [];
        let query = `?year=${year}&type=${type}`;
        const urlMakes = "https://scsbiz.wearevisum.com/api/v1/years" + query;
        const response = await fetch(urlMakes, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).catch(error => console.log('error', error));

        const data = await response?.json();
        if (data.makes.length > 0) {
            setDisabledMakes(false);
        }
        return data.makes.sort();
    }
    const fetchModels = async () => {
        const year = currentAppData?.year;
        const make = currentAppData?.make;
        if (!year) return [];
        if (!make) return [];
        let query = `?year=${year}&make=${make}&type=${type}`;
        const urlMakes = "https://scsbiz.wearevisum.com/api/v1/years" + query;
        const response = await fetch(urlMakes, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).catch(error => console.log('error', error));

        const data = await response?.json();
        // console.log('models', data)
        if (Object.values(data.models).length > 0) {
            setDisabledModels(false);
        }

        if (window.scs_force_normal) {
            setTrims({});
        } else {
            setTrims(data.trims ? data.trims : {});
        }
        return Object.values(data.models).sort();
    }

    const yearsQuery = useQuery({queryKey: ['years'], queryFn: fetchYears})

    const makesQuery = useQuery({queryKey: [`makes-${currentAppData?.year}`], queryFn: fetchMakes})

    const modelsQuery = useQuery({
        queryKey: [`models-${currentAppData?.year}-${currentAppData?.make}`],
        queryFn: fetchModels
    })

    const handleYearChange = (e) => {
        setCurrentAppData(prevState => {
            return {...prevState, year: e.target.value, make: '', model: '', trim: ''}
        })
    }

    const handleMakeChange = (e) => {
        setCurrentAppData(prevState => {
            return {...prevState, make: e.target.value, model: '', trim: ''}
        })
    }

    async function runCheckNow(value: string | undefined, trim: string | undefined, has_trims: boolean) {

        console.log('runCheckNow', value, trim, has_trims);

        if (value != oldModel) {
            setOldModel(value);

            const check = await runCheck(value, trim);
            if (check.compatibility_custom !== 'N'
                && window.scs_force_normal !== true
                && window.is_real_truck !== true) {
                //alert('Need to get custom product via graphql and show the options for custom product');
                if (window.scs_force_custom !== true) {
                    const product = await getCustomProduct(value, '');
                    setCurrentAppData(prevState => {
                        return {...prevState, product: product, check: check, trim: trim, has_trims: has_trims}
                    });
                }
                //product.images = currentAppData?.originalProduct?.images;
                setCurrentAppData(prevState => {
                    return {...prevState, check: check, trim: trim, has_trims: has_trims}
                });
                return;
            }
            setCurrentAppData(prevState => {
                return {...prevState, check: check, trim: trim, has_trims: has_trims}
            });
        }
        return;
    }

    async function runTrims(mm) {
        // console.log('mm:', mm);
        if (trims && typeof trims[mm] !== 'undefined' && trims[mm].length === 1) {
            console.log('runCheckNow runTrims');
            await runCheckNow(mm, trims[mm][0], true);
        }
    }

    const handleModelChange = async (e) => {

        console.log('handleModelChange', e.target.value);
        //let newProduct = {...currentAppData?.product};
        try {
            let newOriginalProduct = {...currentAppData?.originalProduct};
            if (window.scs_force_custom) {
                newOriginalProduct = {...currentAppData?.product};
            } else {
                newOriginalProduct = {...currentAppData?.originalProduct};
            }

            if (newOriginalProduct?.images && newOriginalProduct?.images?.edges) {
                newOriginalProduct.images.edges = newOriginalProduct.images.edges.filter((itm) => itm.node.id.indexOf('VehicleMedia') === -1)
            }

            console.log('handleModelChange 1');

            await setCurrentAppData(prevState => {
                return {...prevState, model: e.target.value, trim: '', originalProduct: newOriginalProduct}
            })
        } catch (error) {
            console.log('handleModelChange error', error);
            await setCurrentAppData(prevState => {
                return {...prevState, model: e.target.value, trim: ''}
            })
        }

        console.log('handleModelChange 1');

        if (currentAppData?.year && currentAppData?.make && e.target.value) {
            //DONE: Run compat check on backend and save compatibility information
            // console.log('trims', trims, e.target.value);
            if (trims && typeof trims[e.target.value] !== 'undefined' && trims[e.target.value].length > 0) {
                await setCurrentAppData(prevState => {
                    return {...prevState, has_trims: true}
                })
                setShowTrims(true);

                setTimeout(async function () {
                    await runTrims(e.target.value);
                }, 10)


            } else {
                console.log('runCheckNow handleModelChange');
                await runCheckNow(e.target.value, '', false);
            }
            return;
        }
        setCurrentAppData(prevState => {
            return {...prevState, check: undefined, trim: '', has_trims: false}
        });
    }

    const handleTrimChange = async (e) => {
        console.log('runCheckNow handleTrimChange');
        await runCheckNow(currentAppData?.model, e.target.value, true);
        //
        // const check = await runCheck(currentAppData?.model, e.target.value);
        // if (check.compatibility === 'N') {
        //     //alert('Need to get custom product via graphql and show the options for custom product');
        //     const product = await getCustomProduct(currentAppData?.model, e.target.value);
        //     product.images = currentAppData?.originalProduct?.images;
        //     await setCurrentAppData(prevState => {
        //         return { ...prevState, product: product }
        //     });
        //     return;
        // }
    }

    const handleClickChange = (e) => {
        setCurrentAppData(prevState => {
            return {
                ...prevState, step: 1, year: '', make: '',
                model: '', seat: '', color: 'Black', addons: '', check: undefined
            };
        })
    }

    const runCheck = async (model, trim) => {
        const check = await fetchCheck(currentAppData?.year, currentAppData?.make, model, trim,
            currentAppData?.color, currentAppData?.seat);
        // console.log(`check result ${currentAppData?.year} ${currentAppData?.make} ${model} ${trim}`, check);
        let newStep = currentAppData?.step;
        if (check.compatibility === 'N' && check.compatibility_custom === 'N') {
            newStep = 3;
        }
        if (check.media && check.media.length > 0) {
            console.log("images", currentAppData);
            //{
            //     "id": "gid://shopify/ProductImage/51056804692260",
            //     "url": "https://cdn.shopify.com/s/files/1/0732/5909/0212/files/black-001_5b326b2c-d6d8-4de5-a845-485370f454e4.jpg?v=1736884658",
            //     "altText": "Your Luxury Seat Covers Front Seats - Black"
            // }
            if (currentAppData?.product?.images) {
                let newProduct = {...currentAppData?.product};
                let newOriginalProduct = {...currentAppData?.originalProduct};

                const videos = check.media
                    .filter((item) => item.media_type.startsWith('video'));

                check.media
                    .filter((item) => item.media_type.startsWith('vthumb-'))
                    .forEach(function (item, index) {
                        if (typeof videos[index] === 'undefined') {
                            return;
                        }
                        console.log('item', item.id);
                        const tmp = {
                            "id": "gid://scsbiz/VehicleMedia/" + item.id,
                            "type": videos[index].media_type,
                            "url": item.media_shopify_url,
                            "video_url": videos[index].media_local_url,
                            "video_type": videos[index].media_type,
                            "altText": `Special Luxury Seat Covers - ${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model} - ${item.id} - all`
                        };
                        console.log('tmp:', tmp);
                        if (newOriginalProduct?.images && newOriginalProduct?.images?.edges && newOriginalProduct?.images.edges.filter((itm) => itm.node.id == tmp.id).length === 0) {

                            //newProduct?.images.edges.push({node: tmp});
                            newOriginalProduct?.images.edges.unshift({node: tmp});
                        }
                    })

                check.media
                    .filter((item) => item.media_type.startsWith('image'))
                    .forEach(function (item, index) {
                        const tmp = {
                            "id": "gid://scsbiz/VehicleMedia/" + item.id,
                            "url": item.media_shopify_url,
                            "altText": `Special Luxury Seat Covers - ${currentAppData?.year} ${currentAppData?.make} ${model} - ${item.id} - all`
                        };
                        console.log('tmp:', tmp);
                        if (newOriginalProduct?.images && newOriginalProduct?.images?.edges && newOriginalProduct?.images.edges.filter((itm) => itm.node.id == tmp.id).length === 0) {

                            //newProduct?.images.edges.push({node: tmp});
                            newOriginalProduct?.images.edges.unshift({node: tmp});
                        }
                    })
                console.log('newProduct:', newProduct);
                await setCurrentAppData(prevState => {
                    return {...prevState, product: newProduct, originalProduct: newOriginalProduct}
                });
                console.log('currentAppData:', currentAppData);


            }

        }

        await setCurrentAppData(prevState => {
            return {...prevState, check: check, trim: trim, has_trims: trim !== '', step: newStep}
        });
        return check;
    }

    const getCustomProduct = (value: string | undefined, trim: string) => {
        custom_refetch();
        // console.log('getCustomProduct data', custom_data);

        return custom_data;
    }

    useEffect(() => {
        if (!currentAppData?.model)
            return;

        // console.log('useEffect model');

        async function runEffect() {


            if (currentAppData?.year && currentAppData?.make && currentAppData?.model) {
                //DONE: Run compat check on backend and save compatibility information
                // console.log('runEffect trims', trims, currentAppData?.model);
                if (trims && typeof trims[currentAppData?.model] !== 'undefined' && trims[currentAppData?.model].length > 0) {
                    await setCurrentAppData(prevState => {
                        return {...prevState, has_trims: true}
                    })
                    setShowTrims(true);

                    setTimeout(async function () {
                        await runTrims(currentAppData?.model);
                    }, 10)


                } else {
                    console.log('runCheckNow runEffect');
                    await runCheckNow(currentAppData?.model, '', false);
                }

                return;
            }
            setCurrentAppData(prevState => {
                return {...prevState, check: undefined, trim: '', has_trims: false}
            });
        }

        runEffect();

        if (currentAppData?.has_trims) {
            // console.log('test: ', typeof trims[currentAppData.model] !== 'undefined' && trims[currentAppData?.model].length > 0);
            setShowTrims(typeof trims[currentAppData.model] !== 'undefined' && trims[currentAppData?.model].length > 0);
        } else {
            // run check
//            runCheckNow(currentAppData?.model, '', false);
        }

    }, []);

    /*useEffect(() => {
        if (!currentAppData?.trim || currentAppData?.trim === '')
            return;

        runCheckNow(currentAppData?.model, currentAppData?.trim, true);

    }, [currentAppData?.trim]);*/


    // console.log('trims', trims, currentAppData?.model, showTrims, trims && currentAppData?.model && showTrims)

    return (
        <section className={`${styles.section__step}`} id="step_1">
            <h2>Step 1/3 - <strong>Vehicle Details</strong></h2>
            {currentAppData?.step === 1 ? (<>
                    <div className={`${styles.vehicle_selector} ${showTrims ? styles.has_trims : ''}`}>
                        <select id={`vehicle-year`} onChange={handleYearChange} defaultValue={currentAppData?.year}
                                data-value={currentAppData?.year}>
                            <option value="">Year</option>
                            {yearsQuery.data && yearsQuery.data.map((year, i) => {
                                return (<option key={`opt-${year}`} value={`${slugify(year)}`}
                                                selected={currentAppData?.year == year}>{year}</option>);
                            })}
                        </select>
                        <select id={`vehicle-make`} onChange={handleMakeChange} disabled={disabledMakes}
                                defaultValue={currentAppData?.make} data-value={currentAppData?.make}>
                            <option value="">Make</option>
                            {makesQuery && makesQuery.data && makesQuery.data.map((make, i) => {
                                return (<option key={`opt-${slugify(make)}-${i}`} value={`${make}`}
                                                selected={currentAppData?.make == make}>{make}</option>);
                            })}
                        </select>
                        <select id={`vehicle-model`} onChange={handleModelChange} disabled={disabledModels}
                                defaultValue={currentAppData?.model} data-value={currentAppData?.model}>
                            <option value="">Model</option>
                            {modelsQuery && modelsQuery.data && modelsQuery.data.map((model, i) => {
                                return (<option key={`opt-${slugify(model)}-${i}`} value={`${model}`}
                                                selected={currentAppData?.model == model}>{model}</option>);
                            })}
                        </select>
                        {
                            trims && currentAppData.model && showTrims ? (
                                <select id={`vehicle-trim`} onChange={handleTrimChange}>
                                    <option value="">Trim</option>
                                    {trims && typeof trims[currentAppData.model] !== 'undefined' && trims[currentAppData.model].map((trim, i) => {
                                        return (<option key={`opt-${slugify(trim)}`} value={`${trim}`}
                                                        selected={trims[currentAppData.model].length === 1}>{trim}</option>);
                                    })}
                                </select>) : ''
                        }

                    </div>
                    {currentAppData.check && currentAppData.check?.alert ?
                        (<div className={`${styles.vehicle_alert}`}>
                            <strong>Warning:</strong> {currentAppData.check?.alert}</div>) : ''}
                </>
            ) : (<div className={`${styles.summary}`}>
                <div
                    className={`${styles.selected_value}`}>{`${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model} ${currentAppData?.trim}`}</div>
                <button className={`${styles.btn_change}`} onClick={handleClickChange}>Change Vehicle</button>
            </div>)}
        </section>
    );
}


